export class CartQf {
  constructor() {
    this.cart = window.QF.cart;

    this.endpoints = {
      add: {
        url: 'cart/add.js',
        method: 'post'
      },
      get: {
        url: 'cart.js',
        method: 'get'
      },
      update: {
        url: 'cart/update.js',
        method: 'post'
      },
      change: {
        url: 'cart/change.js',
        method: 'post'
      },
      clear: {
        url: 'cart/clear.js',
        method: 'post'
      }
    };

    this.selectors = {
      cartDrawerContainer: '[cart-drawer-container]',
      cartTabs: '[side-cart-tab]',
      cartContent: '[side-cart-form]',
      savedCartTab: '[saved-cart-tab]',
      quickViewContainer: '[quick-view-container]',
      sideCartRecommendations: '[side-cart-recommendations]',
      sideCartRecommendationsSection: '[side-cart-recommendations-section]',
      sideCartRecommendationsContainer: '[side-cart-recommended-container]',
      cartRecommendations: '[cart-recommendations]',
      cartRecommendationsSlider: '[cart-recommendations-slider]',
      cartItemsContainer: '[cart-items-container]',
      cartCount: '[cart-count]',
      openSideCartTrigger: '[open-side-cart]',
      sideCartInner: '[side-cart-inner]',
      cartContainer: '[cart-container]',
      sideCartTotal: '[side-cart-total]',
    };
  }

  dispatchEvent(event_name, includeCart) {
    let contents = null;
    if (includeCart) {
      contents = {
        detail: {
          cart: this.cart,
        },
      };
    }
    window.dispatchEvent(new CustomEvent(event_name, contents));
  }

  async add(data) {
    try {
      const responseData = await this.request('add', data);
      this.mergeWithCurrentCart(responseData);
      this.dispatchEvent("cart_changed", true);
      this.dispatchEvent("item_added", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async get() {
    try {
      const response = await this.request('get');
      this.cart = response.data;
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async update(data) {
    try {
      const responseData = await this.request('update', data);
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async change(data) {
    try {
      const responseData = await this.request('change', data);
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async remove(variant_id) {
    try {
      const updates = {
        updates: {
          [variant_id]: 0,
        }
      };
      const { data: responseData } = await this.request('update', updates);
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      this.dispatchEvent("item_removed", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async clear() {
    try {
      const { data: responseData } = await this.request('clear');
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      this.dispatchEvent("cart_cleared", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async request(key, data) {
    try {
      const url = window.Shopify.routes.root + this.endpoints[key].url;
      const method = this.endpoints[key].method;
      const headers = {
        'Content-Type': 'application/json'
      };

      const response = await fetch(url, {
        method,
        headers,
        body: JSON.stringify(data)
      });


      if (response.ok) {
        return response.json();
      } else {
        throw await response.json();
      }
    } catch (error) {

      // Generate Toasty Message
      let options = {
        title: error.message,
        message: error.description,
        delay: 5000
      }
      window.toasty.addToast(options);
      // console.log('🚀🚀🚀 ERROR: ', error);
      // console.log('🚀🚀🚀 DATA: ', data);

      throw error;
    }
  }

  mergeWithCurrentCart(data) {
    if (data.items) {
      data.items.forEach((item) => {
        let index = this.cart.items.findIndex(e => e.id === item.id);
        if (index > -1) {
          this.cart.items[index] = item;
        } else {
          this.cart.items.push(item);
        }
      });
    }
  }

  openSideCart() {
    this.reRenderSideCart(() => {
      const cart_tabs = document.querySelectorAll(this.selectors.cartTabs);
      const cart_content = document.querySelector(this.selectors.cartContent);
      const saved_content = document.querySelector(this.selectors.savedCartTab);
      const quickview = document.querySelector(this.selectors.quickViewContainer);

      if (quickview) {
        quickview.classList.remove('active');
      }

      cart_content.style.display = 'flex';
      saved_content.style.display = 'none';

      cart_tabs[0].classList.add('active');
      cart_tabs[1].classList.remove('active');

      let sideCartContainer = document.querySelector(this.selectors.cartDrawerContainer);
      if (sideCartContainer) {
        sideCartContainer.classList.add("open");
        document.body.classList.add("fixed");
        sideCartContainer.style.height = window.innerHeight + "px";
        window.addEventListener("resize", () => {
          sideCartContainer.style.height = window.innerHeight + "px";
        });
        sideCartContainer.querySelector(this.selectors.sideCartRecommendations).classList.add('open');
        this.dispatchEvent("side_cart_opened", false);
      }
    });
  }

  closeSideCart() {
    let sideCartContainer = document.querySelector(this.selectors.cartDrawerContainer);
    if (sideCartContainer) {
      sideCartContainer.querySelector(this.selectors.sideCartRecommendations).classList.remove('open');
      sideCartContainer.classList.remove("open");
      document.body.classList.remove("fixed");
      this.dispatchEvent("side_cart_closed", false);
    }
  }

  closeSideCartRecommended() {
    let sideCartRecommendations = document.querySelector(this.selectors.sideCartRecommendations);
    if (sideCartRecommendations) {
      sideCartRecommendations.classList.remove('open');
    }
  }

  async reRenderSideCart(successCallback = null) {
    // UPDATE CART COUNT
    const updateCartCount = () => {
      const cart = document.querySelector([this.selectors.cartItemsContainer]);
      let cart_count = cart.getAttribute('data-items-count');
      const cartCountEl = document.querySelectorAll(this.selectors.cartCount);
      const cartBtnEl = document.querySelector([this.selectors.openSideCartTrigger]);

      if (cartBtnEl && cartCountEl && cart && cart_count) {

        cartCountEl.forEach(count_el => {
          if (cart_count == 0) {
            count_el.classList.add('empty-cart');
            cartBtnEl.classList.add('empty-cart');
          } else {
            count_el.classList.remove('empty-cart');
            cartBtnEl.classList.remove('empty-cart');
          }
          count_el.innerHTML = cart_count;
        });
      }
    }

    try {
      const response = await fetch(window.Shopify.routes.root + "cart?sections=kt-side-cart");
      if (!response.ok) {
        throw new Error("Error: " + response.status);
      }
      const data = await response.json();
      const html = data["kt-side-cart"];

      const side_cart_inner = document.querySelector(this.selectors.sideCartInner);
      if (side_cart_inner && html) {
        side_cart_inner.innerHTML = html;
        updateCartCount();

        let first_cart_item = side_cart_inner.querySelector('.item');
        if (first_cart_item) {
          first_cart_item = first_cart_item.dataset.productId;
        }

        if (first_cart_item) {
          const productRecommendationsSection = document.querySelector(this.selectors.cartRecommendations);
          const section_id = productRecommendationsSection.dataset.sectionId;
          const recommendationsUrl = `/recommendations/products?section_id=${section_id}&product_id=${first_cart_item}&limit=5`;

          const recommendationsResponse = await fetch(recommendationsUrl);
          if (recommendationsResponse.ok) {
            const recommendationsText = await recommendationsResponse.text();
            const recommendationsHtml = document.createElement('div');
            recommendationsHtml.innerHTML = recommendationsText;
            const recommendations = recommendationsHtml.querySelector(this.selectors.cartRecommendations);
            if (recommendations && recommendations.innerHTML.trim().length) {
              productRecommendationsSection.innerHTML = recommendations.innerHTML;
              const recommended_product_cards = productRecommendationsSection.querySelectorAll('[product-card]');
              // if (recommended_product_cards.length > 0) {
              //   recommended_product_cards.forEach((card) => {
              //     const view_text = card.dataset.cartLinkText;
              //     if (view_text != "") {
              //       card.querySelector('.product-link').innerHTML = view_text;
              //     }
              //   });
              // }

              new window.swiper('.side-cart-recommendations-slider', {
                slidesPerView: 2.4,
                spaceBetween: 10,
                slidesOffsetBefore: 20,
                slidesOffsetAfter: 20,
                breakpoints: {
                  1200: {
                    slidesPerView: 3.2
                  }
                },
                lazy: {
                  enabled: true,
                  checkInView: false,
                  loadOnTransitionStart: true,
                  loadPrevNext: true,
                  loadPrevNextAmount: 1
                },
              });
            }
          } else {
            throw new Error("Error: " + recommendationsResponse.status);
          }
        }

        if (window.innerWidth > 1199.98) {
          if (first_cart_item) {
            document.querySelector(this.selectors.cartRecommendationsSlider).style.display = 'none';

            const productRecommendationsSection = document.querySelector(this.selectors.sideCartRecommendationsSection);
            const sectionURL = productRecommendationsSection.dataset.url;
            const url = sectionURL.replace("product_id=", "product_id=" + first_cart_item);

            const sectionResponse = await fetch(url);
            if (sectionResponse.ok) {
              const sectionText = await sectionResponse.text();
              const sectionHtml = document.querySelector(this.selectors.sideCartRecommendationsContainer);
              sectionHtml.innerHTML = sectionText;

              new window.swiper('.side-cart-recommendations-slider', {
                slidesPerView: 2,
                spaceBetween: 20,
                navigation: {
                  nextEl: ".swiper-button-next.cart-rec",
                  prevEl: ".swiper-button-prev.cart-rec",
                },
                lazy: {
                  enabled: true,
                  checkInView: false,
                  loadOnTransitionStart: true,
                  loadPrevNext: true,
                  loadPrevNextAmount: 1
                },
                breakpoints: {
                  1134: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                  1500: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },
                },
                on: {
                  init: () => {
                    // Select all product card Swiper containers
                    const productSwipers = document.querySelectorAll('.side-cart-recommendations-slider .productCardSwiper');
                  
                    productSwipers.forEach((swiperEl) => {
                      if (swiperEl.classList.contains('swiper-initialized')) return; // Prevent duplicate initialization
                  
                      new window.swiper(swiperEl, {
                        loop: true,
                        slidesPerView: 1,
                        spaceBetween: 0,
                        navigation: {
                          nextEl: swiperEl.querySelector('.productCardSwiper-next'),
                          prevEl: swiperEl.querySelector('.productCardSwiper-prev'),
                        },
                        lazy: true, // Enable lazy loading
                        preloadImages: false,
                        watchSlidesVisibility: true,
                        watchSlidesProgress: true,
                      });
                  
                      swiperEl.classList.add('swiper-initialized'); // Mark as initialized
                    });
                  }
                }
              });
            } else {
              throw new Error("Error: " + sectionResponse.status);
            }
          } else {
            new window.swiper(".cart-recommendations-slider", {
              slidesPerView: 2,
              spaceBetween: 20,
              navigation: {
                nextEl: ".swiper-button-next.cart-rec",
                prevEl: ".swiper-button-prev.cart-rec",
              },
              lazy: {
                enabled: true,
                checkInView: false,
                loadOnTransitionStart: true,
                loadPrevNext: true,
                loadPrevNextAmount: 1
              },
              breakpoints: {
                1134: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                1500: {
                  slidesPerView: 4,
                  spaceBetween: 20,
                },
              },
              on: {
                init: () => {
                  // Select all product card Swiper containers
                  const productSwipers = document.querySelectorAll('.side-cart-recommendations-slider .productCardSwiper');
                
                  productSwipers.forEach((swiperEl) => {
                    if (swiperEl.classList.contains('swiper-initialized')) return; // Prevent duplicate initialization
                
                    new window.swiper(swiperEl, {
                      loop: true,
                      slidesPerView: 1,
                      spaceBetween: 0,
                      navigation: {
                        nextEl: swiperEl.querySelector('.productCardSwiper-next'),
                        prevEl: swiperEl.querySelector('.productCardSwiper-prev'),
                      },
                      lazy: true, // Enable lazy loading
                      preloadImages: false,
                      watchSlidesVisibility: true,
                      watchSlidesProgress: true,
                    });
                
                    swiperEl.classList.add('swiper-initialized'); // Mark as initialized
                  });
                }
              }
            });
          }
        }
        this.cartRenderedEvent(response, html);

        if (successCallback) {
          successCallback();
        }
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  async reRenderCart() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart?sections=kt-cart`);
      
      if (!response.ok) throw new Error("Network response was not ok");
      
      const data = await response.json();
      const html = data["kt-cart"];
      
      if (!html) throw new Error("Cart HTML data is missing");
      
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;
      
      const cartInner = document.querySelector(this.selectors.cartContainer);
      const newCartContent = tempDiv.querySelector(this.selectors.cartContainer);
      
      if (cartInner && newCartContent) {
        cartInner.innerHTML = newCartContent.innerHTML;
        this.cartRenderedEvent(html);
      } else {
        console.warn("Cart container not found in the DOM or fetched HTML.");
      }
    } catch (error) {
      console.error("Error updating cart:", error);
    }
  }

  cartRenderedEvent(response, html) {
    const event = new CustomEvent("cart_rendered", {
      detail: {
        response,
        html,
      },
    });
    window.dispatchEvent(event);
  }
}

const expressCheckoutTrigger = document.getElementById("express-checkout-trigger");
const expressCheckoutSection = document.getElementById("express-checkout-section");

// Show the express checkout section
if (expressCheckoutTrigger && expressCheckoutSection) {
  expressCheckoutTrigger.addEventListener("click", function () {
    const isSectionHidden = expressCheckoutSection.classList.contains("hidden");
    const openText = expressCheckoutTrigger.getAttribute("data-open-express-checkout-options");
    const closeText = expressCheckoutTrigger.getAttribute("data-close-express-checkout-options");

    const cartDetailsEl = document.querySelector('.cart-details');
    //const recommendationsEl = document.querySelector('[cart-recommendations]');
    if (isSectionHidden) {
      expressCheckoutTrigger.innerText = closeText;
      expressCheckoutSection.classList.remove("hidden");
      // recommendationsEl.classList.remove('open-bundles');
      // const cartDetailsHeight = cartDetailsEl.offsetHeight;
      // recommendationsEl.style.bottom = `calc(${cartDetailsHeight}px - 156px)`;

    } else {
      expressCheckoutTrigger.innerText = openText;
      expressCheckoutSection.classList.add("hidden");
      // const cartDetailsHeight = cartDetailsEl.offsetHeight;
      // recommendationsEl.style.bottom = `${cartDetailsHeight}px`;
    }
  });
}


// Close express checkout if user clicks outside the section
document.addEventListener("click", function (event) {
  const openText = expressCheckoutTrigger.getAttribute("data-open-express-checkout-options");

    if (
        !expressCheckoutSection.contains(event.target) && // Click outside the express checkout section
        !expressCheckoutTrigger.contains(event.target)   // And not on the trigger
    ) {
      if (!expressCheckoutSection.classList.contains("hidden")) {
        expressCheckoutSection.classList.add("hidden");
        expressCheckoutTrigger.innerText = openText;
      }

        // const cartDetailsEl = document.querySelector('.cart-details');
        // const recommendationsEl = document.querySelector('[cart-recommendations]');
        // const cartDetailsHeight = cartDetailsEl.offsetHeight;

        // if (recommendationsEl) {
        //   recommendationsEl.style.bottom = `${cartDetailsHeight}px`;
        // }
    }
});